/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as PlaygroundRouteImport } from "./routes/playground"
import { Route as PoolsRouteImport } from "./routes/pools"
import { Route as PortfolioRouteImport } from "./routes/portfolio"
import { Route as PositionsRouteImport } from "./routes/positions"
import { Route as SwapRouteImport } from "./routes/swap"
import { Route as ChartsTokenAddressRouteImport } from "./routes/charts.$tokenAddress"
import { Route as PoolsPoolIdRouteImport } from "./routes/pools.$poolId"
import { Route as PoolsNewRouteImport } from "./routes/pools.new"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRoute = PlaygroundRouteImport.update({
  id: "/playground",
  path: "/playground",
  getParentRoute: () => rootRouteImport,
} as any)
const PoolsRoute = PoolsRouteImport.update({
  id: "/pools",
  path: "/pools",
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => rootRouteImport,
} as any)
const PositionsRoute = PositionsRouteImport.update({
  id: "/positions",
  path: "/positions",
  getParentRoute: () => rootRouteImport,
} as any)
const SwapRoute = SwapRouteImport.update({
  id: "/swap",
  path: "/swap",
  getParentRoute: () => rootRouteImport,
} as any)
const ChartsTokenAddressRoute = ChartsTokenAddressRouteImport.update({
  id: "/charts/$tokenAddress",
  path: "/charts/$tokenAddress",
  getParentRoute: () => rootRouteImport,
} as any)
const PoolsPoolIdRoute = PoolsPoolIdRouteImport.update({
  id: "/$poolId",
  path: "/$poolId",
  getParentRoute: () => PoolsRoute,
} as any)
const PoolsNewRoute = PoolsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => PoolsRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/playground": typeof PlaygroundRoute
  "/pools": typeof PoolsRouteWithChildren
  "/portfolio": typeof PortfolioRoute
  "/positions": typeof PositionsRoute
  "/swap": typeof SwapRoute
  "/charts/$tokenAddress": typeof ChartsTokenAddressRoute
  "/pools/$poolId": typeof PoolsPoolIdRoute
  "/pools/new": typeof PoolsNewRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/playground": typeof PlaygroundRoute
  "/pools": typeof PoolsRouteWithChildren
  "/portfolio": typeof PortfolioRoute
  "/positions": typeof PositionsRoute
  "/swap": typeof SwapRoute
  "/charts/$tokenAddress": typeof ChartsTokenAddressRoute
  "/pools/$poolId": typeof PoolsPoolIdRoute
  "/pools/new": typeof PoolsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/playground": typeof PlaygroundRoute
  "/pools": typeof PoolsRouteWithChildren
  "/portfolio": typeof PortfolioRoute
  "/positions": typeof PositionsRoute
  "/swap": typeof SwapRoute
  "/charts/$tokenAddress": typeof ChartsTokenAddressRoute
  "/pools/$poolId": typeof PoolsPoolIdRoute
  "/pools/new": typeof PoolsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/playground"
    | "/pools"
    | "/portfolio"
    | "/positions"
    | "/swap"
    | "/charts/$tokenAddress"
    | "/pools/$poolId"
    | "/pools/new"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/playground"
    | "/pools"
    | "/portfolio"
    | "/positions"
    | "/swap"
    | "/charts/$tokenAddress"
    | "/pools/$poolId"
    | "/pools/new"
  id:
    | "__root__"
    | "/"
    | "/playground"
    | "/pools"
    | "/portfolio"
    | "/positions"
    | "/swap"
    | "/charts/$tokenAddress"
    | "/pools/$poolId"
    | "/pools/new"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PlaygroundRoute: typeof PlaygroundRoute
  PoolsRoute: typeof PoolsRouteWithChildren
  PortfolioRoute: typeof PortfolioRoute
  PositionsRoute: typeof PositionsRoute
  SwapRoute: typeof SwapRoute
  ChartsTokenAddressRoute: typeof ChartsTokenAddressRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/playground": {
      id: "/playground"
      path: "/playground"
      fullPath: "/playground"
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/pools": {
      id: "/pools"
      path: "/pools"
      fullPath: "/pools"
      preLoaderRoute: typeof PoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/portfolio": {
      id: "/portfolio"
      path: "/portfolio"
      fullPath: "/portfolio"
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/positions": {
      id: "/positions"
      path: "/positions"
      fullPath: "/positions"
      preLoaderRoute: typeof PositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/swap": {
      id: "/swap"
      path: "/swap"
      fullPath: "/swap"
      preLoaderRoute: typeof SwapRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/charts/$tokenAddress": {
      id: "/charts/$tokenAddress"
      path: "/charts/$tokenAddress"
      fullPath: "/charts/$tokenAddress"
      preLoaderRoute: typeof ChartsTokenAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/pools/$poolId": {
      id: "/pools/$poolId"
      path: "/$poolId"
      fullPath: "/pools/$poolId"
      preLoaderRoute: typeof PoolsPoolIdRouteImport
      parentRoute: typeof PoolsRoute
    }
    "/pools/new": {
      id: "/pools/new"
      path: "/new"
      fullPath: "/pools/new"
      preLoaderRoute: typeof PoolsNewRouteImport
      parentRoute: typeof PoolsRoute
    }
  }
}

interface PoolsRouteChildren {
  PoolsPoolIdRoute: typeof PoolsPoolIdRoute
  PoolsNewRoute: typeof PoolsNewRoute
}

const PoolsRouteChildren: PoolsRouteChildren = {
  PoolsPoolIdRoute: PoolsPoolIdRoute,
  PoolsNewRoute: PoolsNewRoute,
}

const PoolsRouteWithChildren = PoolsRoute._addFileChildren(PoolsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PlaygroundRoute: PlaygroundRoute,
  PoolsRoute: PoolsRouteWithChildren,
  PortfolioRoute: PortfolioRoute,
  PositionsRoute: PositionsRoute,
  SwapRoute: SwapRoute,
  ChartsTokenAddressRoute: ChartsTokenAddressRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
